import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL || '';
const API_URL = `${BASE_URL}/api/rules/`;

var id = 0;

// Set rules for a device
const setRules = async (data, token) => {
    const config = {
        headers: {
            Authorization: `Bearer ${token}`
        }
    }
    const response = await axios.put(API_URL + "set-rules", data, config);
    return response;
};

// Get device rules
const getRules = async (data, token) => {
    const config = {
        headers: {
            Authorization: `Bearer ${token}`
        }
    }
    const response = await axios.post(API_URL + "get-rules", data, config);
    return response;
};

const ruleService = {
    setRules,
    getRules,
};

export default ruleService;